import "antd/dist/antd.css";
import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Form, Icon, Input, Button, Cascader, Select, Row, Col } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class AccountSwitch extends React.Component {
    state = {
        loading: false, // 登录中
        superUnionList: [], // 超盟列表
    };

    componentDidMount () {
        this.fetchSuperUnionList();
    }

    /**
     * 获取超盟列表
     */
    fetchSuperUnionList = () => {
        axios.get("/v1/api/vip/super_union_tree_list").then((res) => {
            res.data = res.data || [];
            res.data.forEach((item) => {
                item.label = `${item.super_union_name}(${item.super_union_id})`;
                item.value = item.super_union_id;
                if (item.union_list && item.union_list.length > 0) {
                    item.union_list.forEach((item2) => {
                        item2.label = `${item2.union_name}(${item2.union_id})`;
                        item2.value = item2.union_id;
                    });
                    item.children = item.union_list;
                }
            });
            this.setState({ superUnionList: res.data });
        });
    };

    /**
     * 切换账号
     */
    handleSwithAccount = () => {
        this.formRef.props.form.validateFields((err, { ids }) => {
            if (!err) {
                this.setState({ loading: true });
                axios
                    .get("/v1/api/vip/switch_union", {
                        params: {
                            union_id: ids[ids.length - 1],
                        },
                    })
                    .then((res) => {
                        this.setState({ loading: false });
                        if (res.code === 1) {
                            const result = res.data;
                            Cookie.set("token", result.token, { expires: 0.1 });
                            Cookie.set("identityType", result.identity, { expires: 0.1 });
                            Cookie.set("name", result.name, { expires: 0.1 });
                            Cookie.set("account", result.account, { expires: 0.1 });
                            Cookie.set("allowCreate", result.allow_create, { expires: 0.1 });
                            Cookie.set("isKpoker", result.is_kpoker, { expires: 0.1 });
                            window.location.href = "/";
                        }
                    });
            }
        });
    };

    render () {
        return (
            <WrappedLoginForm
                {...this.props}
                loading={this.state.loading}
                superUnionList={this.state.superUnionList}
                handleSwithAccount={this.handleSwithAccount}
                wrappedComponentRef={(formRef) => (this.formRef = formRef)}
            />
        );
    }
}

const WrappedLoginForm = Form.create({ name: "normal_login" })(
    class LoginForm extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <div className="switch-account">
                    <h1 className="mb20">{this.props.language["switchAccount"]}</h1>
                    <Form style={{ width: 300 }}>
                        <Form.Item>
                            {getFieldDecorator("ids", {
                                rules: [
                                    {
                                        required: true,
                                        message: this.props.language["unionAccountPlaceholder"],
                                    },
                                ],
                            })(
                                <Cascader
                                    showSearch
                                    allowClear
                                    changeOnSelect
                                    options={this.props.superUnionList}
                                    placeholder={this.props.language["unionAccount"]}
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                style={{ 'width': '100%' }}
                                type="primary"
                                icon="login"
                                loading={this.props.loading}
                                onClick={this.props.handleSwithAccount}
                            >
                                {this.props.language["confirm"]}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            );
        }
    }
);
